// Xpnsr SEO — Russian translations.
// Extracted from the former monolithic frontend/src/i18n.js (1731 lines)
// flagged by the audit report. Pure data; consumed via the
// `translations.ru` re-export in `./index.js`.

export default {
  nav: {
    dashboard: "Дашборд",
    sites: "Проекты",
    pbn: "PBN Сеть",
    audit: "SEO Аудит",
    articles: "Генератор статей",
    promotion: "Продвижение",
    automation: "Автоматизация",
    keywords: "Ключевые слова",
    ranks: "Позиции",
    reports: "Отчёты",
    settings: "API ключи",
    admin: "Админ",
    tip: "→ совет",
    tipText: "Добавьте сайт и запустите аудит",
    signOut: "выйти",
    product: "// продукт",
    navigate: "// разделы",
    dmGroup: "// домены",
    dmDomains: "Домены",
    dmPublisher: "PBN Publisher",
    dmSettings: "Настройки доменов",
    bookDemo: "Заказать демо",
  },
  top: {
    live: "онлайн",
    offline: "оффлайн",
    checking: "проверка",
    searchPlaceholder: "Поиск сайтов, ключей, аудитов…",
  },
  login: {
    heading: "Войти",
    sub: "// SEO TRACKER — ОГРАНИЧЕННЫЙ ДОСТУП",
    email: "EMAIL",
    password: "ПАРОЛЬ",
    emailHolder: "you@xpnsr.tech",
    passHolder: "••••••••••",
    submit: "ВОЙТИ В ДАШБОРД",
    submitting: "ПОДКЛЮЧАЕМСЯ...",
    registerSubmit: "СОЗДАТЬ АККАУНТ",
    registerSubmitting: "СОЗДАЁМ...",
    switchToRegister: "Нет аккаунта? Регистрация",
    switchToLogin: "Уже есть аккаунт? Войти",
    forgotPassword: "Забыли пароль?",
    forgotPasswordHelp: "Напишите на support@xpnsr.tech — сбросим вручную.",
    registerHeading: "Регистрация",
    registerSub: "// БЕТА — БЕСПЛАТНО",
    passwordMinHint: "минимум 8 символов",
    encrypted: "сессия зашифрована · TLS 1.3",
    emailError: "Введите корректный email",
    passError: "Введите пароль",
    connectError: "Ошибка подключения",
    tabSignIn: "Войти",
    tabRegister: "Регистрация",
    heroBack: "снова",
    heroPrefix: "С возвращением",
    heroPrefixRegister: "Создайте",
    heroAccent: "аккаунт",
    heroSub: "// CBN · позиции · бэклинки · контент-сеть",
    statusSession: "сессия",
    statusSessionVal: "шифрование · TLS 1.3",
    statusDataforseo: "dataforseo",
    statusDataforseoVal: "api · подключено",
    statusDeepseek: "deepseek",
    statusDeepseekVal: "кластер · готов",
  },
  dashboard: {
    title: "Дашборд",
    subtitle: "Обзор SEO-показателей ваших сайтов",
    noSites: "Нет добавленных сайтов",
    noSitesDesc: "Добавьте первый сайт для отслеживания",
    addSite: "Добавить сайт",
    totalSites: "Всего сайтов",
    keywords: "Ключевых слов",
    articles: "Статей создано",
    avgPosition: "Средняя позиция",
    avgScore: "Средний балл",
    audits: "Всего аудитов",
    yourSites: "Ваши сайты",
    allSites: "Все сайты →",
    recentAudits: "Последние аудиты",
    quickActions: "Быстрые действия",
    runAudit: "Запустить аудит",
    aiContent: "AI Контент",
    notChecked: "Не проверен",
    noAudits: "Нет аудитов",
    runFirstAudit: "Запустить первый аудит",
    score: "Балл",
    issues: "проблем",
  },
  sites: {
    title: "Проекты",
    subtitle: "Сайты, которые продвигаются через PBN-сеть",
    add: "Добавить проект",
    name: "Название проекта",
    url: "URL",
    provider: "Провайдер",
    providerConfig: "Конфиг провайдера",
    registrar: "Регистратор",
    ipAddress: "IP адрес",
    nsServers: "NS серверы",
    deployedAt: "Последний деплой",
    deploy: "Деплой",
    redeploy: "Повторный деплой",
    createProject: "Создать проект",
    saveProvider: "Сохранить провайдера",
    providerBadge: "Провайдер",
    chooseProvider: "Выберите провайдера",
    cloudflarePages: "Cloudflare Pages",
    vercel: "Vercel",
    netlify: "Netlify",
    githubPages: "GitHub Pages",
    phpHost: "PHP Host",
    external: "Внешний (без деплоя с этой платформы)",
    cfWorker: "Cloudflare Worker (уже развёрнут)",
    optional: "необязательно",
    providerConfigHint:
      "Нужен только для провайдеров, которыми эта платформа сама деплоит сайт (PHP Host, Cloudflare Pages и т.д.). Для «Внешний» и «Cloudflare Worker» оставьте пустым.",
    namePlaceholder: "Мой блог",
    urlPlaceholder: "https://example.com",
    providerConfigPlaceholder:
      '{"project_name":"my-site","account_id":"..."}',
    registrarPlaceholder: "namecheap",
    serpLocation: "Локация SERP",
    serpLocationPlaceholder: "Russia (по умолчанию)",
    serpLanguage: "Язык SERP",
    serpLanguagePlaceholder: "Russian (по умолчанию)",
    serpLocaleHint:
      "DataForSEO location_name / language_name для проверки позиций. Пусто = дефолт платформы (Russia / Russian).",
    serpLocale: "SERP локаль",
    serpDefaultLabel: "По умолчанию",
    editSerpLocale: "Изменить SERP локаль",
    serpLocaleSaved: "SERP локаль обновлена",
    serpLocaleSaveFailed: "Не удалось обновить SERP локаль",
    save: "Добавить сайт",
    cancel: "Отмена",
    delete: "Удалить",
    noSites: "Сайтов пока нет",
    noSitesDesc: "Добавьте первый сайт, чтобы начать отслеживание",
    audit: "Аудит",
    keywords: "ключевых слов",
    articles: "статей",
    lastAudit: "Последний аудит",
    score: "Оценка",
    added: "Добавлен",
    siteAdded: "Проект добавлен",
    siteDeleted: "Сайт удалён",
    auditComplete: "Аудит завершён",
    loadError: "Ошибка загрузки сайтов",
    deleteError: "Ошибка удаления сайта",
    deleteTitle: "Удалить сайт?",
    deleteDesc:
      "Это действие нельзя отменить. Все данные аудитов и ключевых слов будут удалены.",
    notChecked: "Не проверялся",
    noProviderData: "Нет данных провайдера",
    deploymentQueued: "Деплой поставлен в очередь",
    deploymentDone: "Деплой завершён",
    deploymentFailed: "Ошибка деплоя",
    errors: {
      invalidUrl: "Введите корректный URL",
      addFailed: "Не удалось добавить сайт",
      deleteFailed: "Не удалось удалить сайт",
      invalidProviderConfig: "Конфиг провайдера должен быть валидным JSON",
    },
  },
  keywords: {
    title: "Ключевые слова",
    subtitle: "Отслеживайте позиции по важным запросам",
    add: "Добавить",
    keyword: "Ключевое слово",
    placeholder: "например: лучшие ноутбуки 2026",
    position: "Позиция",
    added: "Добавлено",
    actions: "Действия",
    noKeywords: "Нет ключевых слов",
    noKeywordsDesc: "Добавьте ключевые слова для отслеживания",
    checkAll: "Проверить все",
    check: "Проверить",
    checking: "Проверяем...",
    delete: "Удалить",
    added: "Ключевое слово добавлено",
    deleted: "Ключевое слово удалено",
    posFound: (pos) => `Позиция: ${pos} (DataForSEO)`,
    notInTop100: "Сайт не найден в топ-100 по этому запросу",
    loadError: "Ошибка загрузки ключевых слов",
    errors: {
      empty: "Введите ключевое слово",
      duplicate: "Это ключевое слово уже существует",
      addFailed: "Ошибка добавления",
      deleteFailed: "Ошибка удаления",
      checkFailed: "Ошибка проверки позиции",
    },
  },
  ranks: {
    title: "Отслеживание позиций",
    subtitle: "Мониторинг позиций по ключевым словам",
    noSites: "Нет сайтов",
    noKeywords: "Нет ключевых слов",
    noSitesDesc: "Сначала добавьте сайт",
    noKeywordsDesc: 'Добавьте ключевые слова на странице "Ключевые слова"',
    checkNow: "Проверить позиции",
    checking: "Проверяем...",
    lastCheck: "✓ Последняя проверка через DataForSEO",
    lastCheckedSummary: (count, engine, time) =>
      `Последняя проверка: ${count} ключей · ${engine} · ${time}`,
    dataSource: "Позиции тянутся из Google/Yandex через DataForSEO — реальные данные, без симуляции.",
    dataSourceHint:
      "Чтобы проверка работала, нужны логин и пароль DataForSEO.",
    goToSettings: "Открыть Settings → API keys",
    currentPosition: "Текущая позиция",
    keywords: "Ключевые слова",
    history: "История",
    current: "Текущая",
    best: "Лучшая",
    checks: "Проверок",
    noData: "Нет данных о позициях",
    noDataDesc: "Нажмите «Проверить позиции» — данные подтянутся из DataForSEO",
    currentPos: "Текущая позиция",
    position: "Позиция",
    dfsChecked: (n) => `Проверено ${n} ключевых слов`,
    dfsNotConfig:
      "Не настроены логин/пароль DataForSEO — заполните их в Settings → API keys",
    dfsUnauthorized:
      "DataForSEO отверг логин/пароль. Перепроверьте их в Settings → API keys",
    dfsError: "Ошибка DataForSEO",
    unknownError: "Неизвестная ошибка",
    offTop100Summary: (n) =>
      `из них ${n} — не в топ-100`,
    offTop100Tooltip:
      "Проверки, в которых сайт не нашёлся в топ-100 — в график они не попадают, чтобы не создавать ложных спайков на тренде.",
  },
  articles: {
    title: "Генератор SEO-статей",
    subtitle: "Создавайте полноценные статьи для продвижения в топ",
    noSites: "Нет сайтов",
    noSitesDesc: "Сначала добавьте сайт",
    generator: "Генератор",
    single: "Одна статья",
    bulk: "Массово",
    site: "Сайт",
    keyword: "Ключевое слово",
    keywordHolder: "Например: как выбрать ноутбук",
    language: "Язык",
    generate: "Сгенерировать статью",
    generating: "Генерация (~30 сек)...",
    bulkKeywords: "Ключевые слова (по одному на строку)",
    bulkHolder:
      "как выбрать ноутбук\nлучшие ноутбуки 2024\nноутбук для работы",
    bulkMax: "Максимум 10 статей за раз",
    generateAll: "Сгенерировать все",
    generatingAll: "Генерация...",
    list: "Сгенерированные статьи",
    noArticles: "Статей пока нет",
    words: "слов",
    published: "✓ Опубликовано",
    preview: "Предпросмотр",
    viewRendered: "Превью",
    viewSource: "HTML",
    title_: "Title:",
    meta: "Meta Description:",
    content: "Контент:",
    copyHTML: "Копировать HTML",
    republish: "Переотправить",
    webhook: "Webhook",
    toPBN: "В PBN",
    assignTitle: "Отправить в PBN кампанию",
    article_: "Статья:",
    campaign: "Кампания",
    satellite: "Сателлит",
    selectCamp: "Выберите кампанию...",
    selectSat: "Выберите сателлит...",
    noSatellites: "В этой кампании нет сателлитов с webhook URL",
    send: "Отправить в PBN",
    sending: "Отправляем...",
    close: "Отмена",
    published_: "Опубликовано",
    downloaded: (filename) => `Скачано: ${filename}`,
    publishedWebhook: "Опубликовано через webhook",
    webhookNotConfig:
      "Webhook не настроен — перейдите в Автоматизацию и укажите URL",
    errors: {
      noKeyword: "Введите ключевое слово",
      noKeywords: "Введите ключевые слова",
      tooMany: (k) =>
        `Максимум 10 ключевых слов, у вас ${k} — лишние будут проигнорированы`,
      none: "Не удалось сгенерировать ни одной статьи",
      timeout:
        "Генерация заняла слишком много времени — обновите страницу, статьи могут уже быть готовы",
      loadFailed: "Ошибка загрузки",
    },
  },
  pbn: {
    title: "PBN Сеть",
    subtitle: "Управляйте сателлитами и продвигайте целевые сайты через сеть",
    overview: "Обзор",
    satellites: "Сателлиты",
    campaigns: "Кампании",
    articles_: "Статьи",
    stats: {
      satellites: "Сателлитов",
      campaigns: "Кампаний",
      articles: "Статей",
      published: "Опубликовано",
    },
    sat: {
      deselectAll: "Снять выбор",
      selectAll: "Выбрать все",
      whiteRefresh: "Переустановить white page",
      whiteInstall: "Установить white page",
      toasts: {
        enterDomains: "Введите хотя бы один домен",
        added: (n) => `Добавлено ${n} доменов`,
        addError: "Не удалось добавить домены",
        deleted: "Удалено",
        deleteError: "Ошибка удаления",
        whiteStarted: (name) => `Генерация запущена для ${name}`,
        whiteReady: (name) => `White page для ${name} готов!`,
        whiteError: (msg) => `Ошибка: ${msg}`,
        whiteGenericError: "Ошибка генерации",
        pickSats: "Выберите хотя бы один сателлит",
        bulkStarted: (n) => `Запущена генерация для ${n} сателлитов`,
        bulkSkipped: (n) => `Пропущено ${n} сателлит(ов) (нет worker URL или не найден)`,
        bulkDone: (ok, fail) => `Готово: ${ok} успешно, ${fail} ошибок`,
        bulkGenericError: "Ошибка",
      },
      title: "Домены сателлитов",
      subtitle: "Добавляйте домены списком для своей сети",
      add: "Добавить домены",
      domainsLabel: "Домены (по одному на строку)",
      domainsHolder: "example.com\nmysite.net\nblog.io",
      webhookLabel: "Webhook URL (необязательно, для всех)",
      webhookHolder: "https://domain.com/publish.php",
      providerLabel: "Провайдер",
      providerHolder: "cloudflare_pages",
      ipAddress: "IP адрес",
      registrar: "Регистратор",
      nsServers: "NS серверы",
      deployedAt: "Последний деплой",
      diversityScore: "Оценка разнообразия",
      count: (d) => `${d} доменов`,
      addBtn: "Добавить сателлиты",
      adding: "Добавление...",
      noSats: "Сателлитов пока нет",
      noSatsDesc: "Добавьте домены сателлитов, чтобы собрать свою PBN",
      articles: "статей",
      noWebhook: "Нет webhook",
      webhook: "Webhook URL",
      save: "Сохранить",
      cancel: "Отмена",
      delete: "Удалить",
      confirmDelete: "Удалить этот сателлит?",
    },
    camp: {
      title: "Кампании",
      subtitle: "Свяжите целевой сайт с сателлитами и генерируйте статьи",
      new: "Новая кампания",
      name: "Название кампании",
      namePlaceholder: "Продвижение mysite.com",
      targetSite: "Целевой сайт (который продвигаем)",
      selectSite: "Выберите сайт",
      keywords: "Ключевые слова (по одному на строку)",
      keywordsHolder:
        "купить ноутбук\nлучшие ноутбуки 2025\nноутбук для работы",
      anchors: "Анкоры ссылок (по одному на строку)",
      anchorsHolder:
        "Acme\nплатформа Acme\nлучший трекер задач\nдашборд Acme",
      anchorsHelp:
        "Обязательное поле. Смешивайте брендовые (название сайта), тематические (ключевые слова) и описательные анкоры. Избегайте generic-анкоров вида «подробнее» / «читать далее» — они создают межкампанийный footprint, который аудиторы беклинков флагают как токсичный.",
      anchorsRequired: "Добавьте анкоры (хотя бы один)",
      satellitesRequired: "Выберите хотя бы один сателлит",
      autofillBtn: "Сгенерировать ключи и анкоры",
      autofillHint:
        "Выберите сайт оффера и сателлиты — ИИ сам заполнит пулы ключей и анкоров ниже. Размер пула масштабируется под число сателлитов. Проверьте и отредактируйте перед созданием.",
      autofillBtnMore: "Догенерировать ключи и анкоры (ИИ)",
      autofillHintEdit:
        "Новые ключи и анкоры добавятся к уже имеющимся ниже, а не заменят их — проверьте список перед сохранением.",
      autofillNeedsSite: "Сначала выберите сайт оффера",
      autofillNeedsSats:
        "Сначала выберите сателлиты — размер пула масштабируется под их число",
      autofillProjection: "≈ {k} ключей / {a} анкоров на {s} сателлитов",
      autofillBusy: "Генерирую ключи и анкоры…",
      autofillDone: "Сгенерировано: {k} ключей и {a} анкоров",
      autofillError: "Не удалось сгенерировать",
      targetUrls: "Целевые URL (по одному на строку, необязательное)",
      targetUrlsHolder:
        "https://example.com/\nhttps://example.com/features\nhttps://example.com/pricing",
      targetUrlsHelp:
        "Необязательно. Беклинки распределяются по этому пулу URL — повторите URL на новой строке, чтобы дать ему больше веса. Если оставить пустым, все ссылки пойдут на главную страницу таргета (это создаёт сильный PBN-footprint).",
      satellites: "Сателлиты для этой кампании",
      noSats: "Сначала добавьте домены-сателлиты",
      selected: (n) => `Выбрано: ${n}`,
      perSat: "Статей на сателлит",
      language: "Язык статей",
      create: "Создать кампанию",
      creating: "Создаём...",
      noCamps: "Нет кампаний",
      noCampsDesc: "Создайте кампанию для связи целевого сайта с сателлитами",
      generate: "Генерировать",
      publish: "Публиковать",
      delete: "Удалить",
      confirmDelete: "Удалить кампанию и все её статьи?",
      deleteTitle: "Удалить кампанию?",
      deleteIntro: "«{name}» будет удалена.",
      deleteArticlesNote: "К ней привязано {n} статей.",
      deleteAlsoArticles: "Также удалить черновики ({n} привязано)",
      deleteAlsoArticlesHelp:
        "Выкл (по умолчанию): все статьи отсоединяются и остаются в разделе «Статьи». Вкл: удаляются только неопубликованные черновики — уже опубликованные статьи всегда сохраняются, чтобы их живые бэклинки продолжали работать.",
      deleteCancel: "Отмена",
      deleteConfirmKeep: "Удалить кампанию, оставить статьи",
      deleteConfirmAll: "Удалить кампанию и черновики",
      deletedKeptToast: "Кампания удалена, статей сохранено: {n}",
      deletedAllToast: "Кампания удалена (черновиков удалено: {removed}, опубликованных сохранено: {kept})",
      unlock: "Снять блокировку",
      unlocked: "Блокировка снята",
      recount: "Пересчитать",
      recounted: "Счётчики обновлены",
      generating: "Генерация\u2026",
      publishing: "Публикация\u2026",
      settings: "Настройки",
      settingsTitle: (n) => `Настройки кампании: ${n}`,
      status: "Статус",
      statusActive: "Активна",
      statusPaused: "Пауза",
      statusDone: "Завершена",
      saveChanges: "Сохранить изменения",
      cancel: "Отмена",
      satsLabel: "Сателлиты",
      satCount: (n) => `Выбрано: ${n}`,
      keywordsLabel: "ключей",
      articlesLabel: "статей",
      publLabel: "опубл.",
      viewArticles: "Статьи",
      viewArticlesTitle: "Открыть вкладку «Статьи», отфильтрованную по этой кампании",
      liveCountersTooltip: "Живые счётчики — обновляются автоматически каждые 15 с",
      cadenceLabel: "Частота публикации (статей / день)",
      cadenceOff: "Выкл (без лимита)",
      cadenceDay: "день",
      cadenceCustom: "Своё значение\u2026",
      cadenceCustomAria: "Своё число статей в день (1\u2013500)",
      cadenceHelp:
        "Выберите пресет или задайте своё значение (1\u2013500). Планировщик автоматически публикует до N черновиков в день (по UTC). Выкл = publish-bulk отправляет всё разом.",
    },
    art: {
      title: (n) => `PBN Статьи (${n})`,
      recentArticles: "Последние статьи",
      selectToView: "Выберите статью для просмотра",
      titleLabel: "Заголовок:",
      metaLabel: "Мета:",
      backlinksLabel: "Обратные ссылки:",
      contentLabel: "Контент:",
      refresh: "Обновить",
      campaign: "Кампания",
      allCamps: "Все кампании",
      status: "Статус",
      allStatuses: "Все статусы",
      published_: "Опубликованные",
      draft: "Черновики",
      failed: "С ошибкой",
      noArticles: "Нет статей",
      noArticlesDesc: "Сначала сгенерируйте статьи в кампании",
      publish: "Опубликовать",
      publishing: "Публикуем...",
      copy: "Копировать",
      preview: "Просмотр",
      delete: "Удалить",
      confirmDelete: "Удалить эту статью?",
      keyword: "Ключевое слово:",
      site: "Сайт:",
      satellite: "Сателлит:",
      words: "слов",
      backlinks: "обратных ссылок",
      detachedFrom: "от удалённой: {name}",
      detachedFromTitle:
        "Кампания «{name}» была удалена. Статья сохранена, чтобы не ломать уже опубликованную ссылку на сателлите.",
      contentPreview: "Превью контента:",
    },
    // Tier-2/3 админ-действия (Replay CF KV, Cleanup audit, Sync platforms
    // и кнопки запуска tier-2/3 в карточке кампании). Раньше строки были
    // захардкожены в CampaignsTab.jsx / CampaignCard.jsx / SyncPlatformsPanel.jsx;
    // вынесено сюда по аудиту 1.4.7.
    tier23: {
      phase: {
        tier2: "Только Tier-2",
        tier3: "Только Tier-3",
        both: "Tier-2/3",
      },
      starting: (label) => `Запускаю ${label} backlinks…`,
      startedTier3: (label) =>
        `${label} запущен в фоне — источники берутся из уже опубликованных Tier-2 постов кампании. Обновите страницу через несколько минут.`,
      startedBulk: (label, n) =>
        `${label} запущен в фоне для ${n} сателлитов — обновите страницу через несколько минут.`,
      errorPrefix: (label) => `Ошибка ${label}: `,
      tryLater: "Попробуйте позже",
      onlyAdmin: "только админ",
      later: "позже",
      buttons: {
        bothTitle: "Запустить Tier-2 и Tier-3 последовательно",
        bothTitleDisabled: "Сначала опубликуйте статьи",
        tier2Title: "Запустить только Tier-2 (без Tier-3)",
        tier3Title:
          "Запустить только Tier-3 (источники — уже опубликованные Tier-2 без Tier-3 бэклинка)",
      },
      viewer: {
        button: "T2/T3 список",
        buttonTitle:
          "Посмотреть все Tier-2 и Tier-3 публикации этой кампании — клик по ссылке откроет реальную страницу.",
        title: "Tier-2 / Tier-3 публикации",
        intro:
          "Кликни по любой ссылке чтобы открыть реальный опубликованный пост на сторонней площадке в новой вкладке.",
        filter: "Фильтр:",
        all: "Все",
        publishedOnly: "Опубликованные",
        failedOnly: "Неудачные",
        refresh: "Обновить",
        tier2Header: "Tier-2",
        tier3Header: "Tier-3",
        empty:
          "Пока пусто. Запусти T2/T3 на карточке кампании чтобы появились записи.",
        openLink: "Открыть в новой вкладке",
        noUrl: "нет публичного URL",
        anchor: "анкор",
        sat: "сателлит",
        target: "цель",
        source: "источник",
      },
      replay: {
        running: "Повторяю quota-blocked статьи…",
        error: "Ошибка replay: ",
        btnTitle: "Повторно отправить статьи, застрявшие из-за лимитов CF KV",
      },
      cleanup: {
        summaryHeader: "Найдено к удалению:",
        tier2Failed: (n) => `• Tier-2 failed: ${n}`,
        tier3Failed: (n) => `• Tier-3 failed: ${n}`,
        removedAdapters: (n, detail) =>
          `• Tier-2 от удалённых адаптеров: ${n}${detail ? ` (${detail})` : ""}`,
        staleFlags: (n) => `• Stale CF KV flags: ${n}`,
        orphansHeader:
          "Осиротевшие записи (НЕ будут удалены, только репорт):",
        articlesNoCampaign: (n) => `• Articles без кампании: ${n}`,
        articlesNoSatellite: (n) => `• Articles без сателлита: ${n}`,
        tier2NoSatellite: (n) => `• Tier-2 без сателлита: ${n}`,
        confirm: "Удалить и почистить флаги? (отмена = ничего не делать)",
        cancelled: "Cleanup отменён",
        success: (c) =>
          `Cleanup готов: -${c.t2 || 0} t2, ` +
          `-${c.t3 || 0} t3, ` +
          `-${c.adapters || 0} удал. адаптеров, ` +
          `-${c.staleFlags || 0} stale flags, ` +
          `+${c.backfill || 0} backfilled, ` +
          `~${c.counters || 0} счётчиков`,
        error: "Ошибка cleanup: ",
        btnTitle:
          "Удалить failed-строки tier-2/3, очистить устаревшие quota-флаги, добавить campaign_id где возможно. Сначала покажет цифры, потом спросит подтверждение.",
      },
      sync: {
        panelTitle: "Sync platforms — reconcile audit с реальными URL",
        modeLabel: "Режим",
        modeOptionPlatforms: "По платформам (имена адаптеров через запятую)",
        modeOptionWhitelist: "По whitelist (вставьте валидные URL)",
        behaviorLabel: "Поведение при Apply",
        behaviorSoft: "Mark invalid (обратимо, рекомендуется)",
        behaviorHard: "Hard delete (НЕОБРАТИМО)",
        platformsLabel: "Платформы (через запятую)",
        platformsHelp:
          "Имена адаптеров как в поле `platform` аудит-строк. " +
          "Активные: telegraph, devto, tumblr, wp_bridge, justpaste, writeas, pastebin, " +
          "telegraph_t3, archive_org, archive_today, graph_org, rentry, dpaste_com. " +
          "Удалённые/забаненные (для зачистки старых строк): wordpress, github_gist, hashnode, medium.",
        whitelistLabel: "Whitelist URL (один на строку)",
        whitelistHelp:
          "Строки в pbn_tier2/3_posts, чей `public_url` НЕ в этом списке, будут " +
          "помечены/удалены. Сравнение регистрозависимое; trailing slash режется автоматически. " +
          "Пустые строки и строки с `#` игнорируются.",
        platformsRequired: "Укажите хотя бы одну платформу (напр. wordpress)",
        urlsRequired:
          "Вставьте список URL (один на строку) — пустой ввод не допускается",
        dryRunBtn: "Dry-run (посмотреть цифры)",
        dryRunInfo: (n) =>
          `Dry-run: ${n} строк под фильтр. Посмотрите разбивку ниже и нажмите Apply.`,
        dryRunError: "Ошибка dry-run: ",
        dryRunResultHeader: "Dry-run результат:",
        matchingRows: "подходящих строк",
        verbHard: "УДАЛИТЬ навсегда",
        verbSoft: "пометить invalid",
        modeHard: "НЕОБРАТИМО",
        modeSoft: "обратимо — status='invalid'",
        confirm: (verb, n, mode) => `${verb} ${n} строк? (это ${mode})`,
        cancelled: "Sync отменён",
        success: (n, mode) =>
          `Sync готов: ${n} строк ${mode}. Счётчики пересчитаются на рефреше.`,
        successDeleted: "удалено",
        successInvalid: "помечено invalid",
        error: "Ошибка sync: ",
        btnTitle:
          "Сверить pbn_tier2/3_posts с реальными URL на платформах. Два режима: по имени платформы (напр. wordpress) или по списку валидных URL.",
      },
    },

    brandIdentity: {
      buttonTitle: "Задать бренд-идентичность для всех сателлитов этой кампании",
      title: "Бренд-идентичность",
      description:
        "Устанавливает одинаковый Organization JSON-LD (название, лого, официальные ссылки) на всех сателлитах кампании — так поисковики объединяют их в одну распознаваемую сущность вместо набора анонимных доменов.",
      warningTitle: "Противоположность анти-footprint: прочитайте перед использованием",
      warningBody:
        "Это записывает ОДИНАКОВЫЕ структурированные данные (имя, лого, ссылки) на все сателлиты кампании — прямой, машиночитаемый сигнал, что это один и тот же издатель. Всё остальное в этой сети (анкоры, авторы, домашние страницы) намеренно делается уникальным именно чтобы избежать такого паттерна. Используйте это только на сателлитах, которые вы ХОТИТЕ показать поисковику как единый видимый бренд — никогда как рутинное действие на сети, которая должна выглядеть независимой.",
      confirmLabel:
        "Я понимаю, что это свяжет все сателлиты кампании друг с другом через публичные структурированные данные, и я этого хочу.",
      name: "Название",
      legalName: "Юридическое название",
      logoUrl: "URL логотипа",
      sameAs: "Официальные ссылки (sameAs) — по одной на строку",
      sameAsHint:
        "URL соцсетей/профилей, подтверждающие ту же реальную организацию — питают граф сущностей Google.",
      contactEmail: "Контактный email",
      contactUrl: "URL страницы контактов",
      foundingDate: "Дата основания",
      descriptionLabel: "Описание",
      appliesTo: "Применится ко всем сателлитам кампании ({n} шт.).",
      cancel: "Отмена",
      save: "Применить к кампании",
      saved: "Бренд-идентичность применена к {n} сателлитам",
      saveError: "Не удалось сохранить бренд-идентичность",
    },
  },
  audit: {
    title: "SEO Аудит",
    subtitle: "Технический анализ ваших сайтов",
    run: "Запустить аудит",
    running: "Анализируем...",
    foundIssues: (n) => `Найдено проблем (${n})`,
    score: "Оценка",
    issues: "Проблемы",
    lastAudit: "Последний аудит",
    noSites: "Нет сайтов",
    noSitesDesc: "Сначала добавьте сайт",
    noAudit: "Нет данных аудита",
    noAuditDesc: "Запустите аудит для получения результатов",
    noAuditYet: "Аудит ещё не проведён",
    runFirstAudit: "Запустите первый аудит для выбранного сайта",
    robots: "Robots",
    notSpecified: "Не указано",
    withoutAlt: "Без alt",
    images: "картинок",
    critical: "Критические",
    high: "Высокие",
    medium: "Средние",
    low: "Низкие",
  },
  automation: {
    title: "Автоматизация",
    subtitle: "Автоматические задачи и уведомления",
    overviewTitle: "С чего начать",
    overviewDesc:
      "Автоматизация делает 3 вещи: проверяет позиции по расписанию, шлёт алерты в Telegram и публикует статьи на ваш сайт через webhook. Включайте по порядку — что-то одно, потом следующее.",
    step1Title: "1. Проверка позиций по расписанию",
    step1Body:
      "Раз в N часов система забирает позиции из DataForSEO и пишет историю. Требуются логин/пароль DataForSEO в Settings → API keys.",
    step2Title: "2. Уведомления в Telegram",
    step2Body:
      "Бот пишет вам в Telegram, когда позиции заметно меняются (вход в ТОП-10, выход из ТОП-100 и т.п.). Нужны Bot Token и Chat ID — инструкции в карточке ниже.",
    step3Title: "3. Авто-публикация статей",
    step3Body:
      "Webhook отправляет сгенерированные статьи на ваш сайт/CMS. Укажите URL эндпоинта (опционально — секрет для подписи запроса).",
    statusReady: "Готово",
    statusOff: "Не настроено",
    nextRun: "Следующая автопроверка",
    scheduler: "Планировщик задач",
    schedulerDesc: "Автоматическая проверка позиций по расписанию",
    active: "Активен",
    paused: "Приостановлен",
    pause: "⏸ Пауза",
    resume: "▶ Включить",
    interval: "Интервал проверки",
    apply: "Применить",
    runNow: "▶ Запустить сейчас",
    running: "Выполняется...",
    every1h: "Каждый час",
    every3h: "Каждые 3 часа",
    every6h: "Каждые 6 часов",
    every12h: "Каждые 12 часов",
    everyDay: "Раз в день",
    webhook: "Webhook — автопубликация статей",
    webhookDesc:
      "Автоматически отправляйте статьи на ваш сайт или CMS через HTTP webhook",
    webhookURL: "Webhook URL",
    webhookHolder: "https://your-site.com/api/publish",
    webhookHint: "Эндпоинт, который принимает POST-запрос с JSON статьи",
    secret: "Secret (необязательно)",
    secretHolder: "your-webhook-secret",
    secretHint:
      "Подписывает запрос заголовком X-Webhook-Signature (HMAC SHA256)",
    save: "Сохранить",
    test: "Тест",
    telegram: "Telegram уведомления",
    telegramDesc: "Получайте уведомления об изменениях позиций",
    notConfigured: "Не настроен",
    botToken: "Bot Token",
    chatId: "Chat ID",
    connect: "Подключить Telegram",
    connecting: "Подключаем...",
    testTelegram: "Тестовое уведомление",
    botTokenHelp: "Как получить токен бота:",
    chatIdHelp: "Как получить Chat ID:",
    step1: "Напишите @BotFather в Telegram",
    step2: "Отправьте /newbot и следуйте инструкциям",
    step3: "Скопируйте полученный токен",
    step4: "Напишите @userinfobot в Telegram",
    step5: "Скопируйте ваш ID (числовой)",
    connected: "Подключён",
    testSent: "Тестовое сообщение отправлено",
    sendError: "Ошибка отправки",
    enterWebhookUrl: "Введите Webhook URL",
    webhookResponse: (n) => `Webhook ответил: ${n}`,
    webhookConnectErr: "Не удалось подключиться к webhook",
    webhookReady: "Webhook настроен и готов к работе",
    notifyAbout: "Вы будете получать уведомления о:",
    notify1: "Изменениях позиций на 5+ пунктов",
    notify2: "Вхождении в ТОП-10",
    notify3: "Выходе из ТОП-100",
    autoActions: "Автоматические действия",
    posChecksTitle: "Проверка позиций",
    posChecksDesc: (n) =>
      `Каждые ${n} ч. система проверяет позиции ключевых слов через DataForSEO`,
    autoIndexTitle: "Авто-индексация",
    autoIndexDesc:
      "При генерации статьи URL автоматически отправляется в Yandex, Bing и Google",
    notifTitle: "Уведомления",
    notifDesc: "Telegram бот мгновенно уведомит вас об изменениях позиций",
    payloadFormat: "Формат данных (JSON):",
    compatible: "Совместимо с:",
    compatibleList: "WordPress REST API, Ghost CMS, Strapi, любой backend",
    publishPbn: "Публикация PBN статей",
    selectCampaign: "Выберите PBN кампанию",
    publishPbnBtn: "Опубликовать все черновики PBN",
  },
  promotion: {
    title: "Инструменты продвижения",
    subtitle: "Всё для вывода сайта в топ поисковых систем",
    noSites: "Нет сайтов",
    noSitesDesc: "Сначала добавьте сайт",
    selectSite: "Выберите сайт",
    competitors: "Конкуренты",
    plan: "План продвижения",
    linkBuilding: "Линкбилдинг",
    indexation: "Индексация",
    comp: {
      cardTitle: "Анализ конкурентов",
      cardDesc: "Узнайте, что делают топ-10 сайтов по вашему запросу",
      keyword: "Ключевое слово",
      keyHolder: "Например: купить ноутбук онлайн",
      analyze: "Анализировать",
      resultTitle: "Результат анализа",
      difficulty: "Сложность запроса",
      wordCount: "Рекомендуемый объём статьи",
      words: "слов",
      lsi: "LSI-ключи:",
      strategy: "Рекомендуемая стратегия:",
      empty: "Введите ключевое слово и нажмите «Анализировать»",
    },
    planCard: {
      desc: "ИИ составит подробный план на 3 месяца",
      keysLabel: "Целевые ключевые слова (по одному на строку)",
      keysHolder: "купить ноутбук\nноутбук для работы\nлучший ноутбук 2026",
      budgetLabel: "Бюджет",
      budgetLow: "Минимальный (только время)",
      budgetMed: "Средний (до $500/мес)",
      budgetHigh: "Высокий ($500+/мес)",
      create: "Создать план",
      copy: "Копировать",
      empty: "Введите ключевые слова для создания плана",
    },
    backlinks: {
      cardTitle: "Создать задачу линкбилдинга",
      cardDesc: "ИИ даст рекомендации по получению обратных ссылок",
      urlLabel: "URL страницы для продвижения",
      urlHolder: "https://yoursite.com/article",
      anchorLabel: "Анкор (текст ссылки)",
      anchorHolder: "купить ноутбук",
      getBtn: "Получить рекомендации",
      resultTitle: "Рекомендации по линкбилдингу",
      empty: "Заполните форму для получения рекомендаций",
    },
    index: {
      cardTitle: "Авто-индексация URL",
      cardDesc: "Отправьте URL во все поисковики одним кликом",
      urlsLabel: "URL (по одному на строку)",
      allBtn: "Всё сразу",
      note: "IndexNow: Yandex, Bing • Google: требует настройки",
      googleLabel: "Google Indexing API",
      instruction: "Пошаговая инструкция",
      credHolder:
        "Вставьте JSON-ключ Service Account из Google Cloud Console...",
      saveCreds: "Сохранить credentials Google",
      resultTitle: "Результат",
      submitted: (n) => `Отправлено: ${n} URL`,
      setupTitle: "Настройка Google Indexing API:",
      credsSaved: "✓ Credentials Google сохранены",
      empty: "Введите URL и нажмите «Всё сразу»",
      emptySub: "или настройте Google Indexing API",
      addAccount: "○ Добавьте Google Service Account",
      googleSent: (n) => `✓ ${n} URL отправлено`,
      important: "Важно:",
      indexSatellites: "Индексировать все PBN сателлиты",
    },
    toast: {
      loadErr: "Ошибка загрузки",
      enterKw: "Введите ключевое слово",
      analyzed: "Анализ завершён",
      analysisErr: "Ошибка анализа",
      enterKws: "Введите ключевые слова",
      planCreated: "План создан",
      planErr: "Ошибка создания плана",
      fillFields: "Заполните все поля",
      taskCreated: "Задача создана",
      taskErr: "Ошибка создания задачи",
      enterUrl: "Введите URL",
      sitemapDone: "Sitemap создан",
      sitemapErr: "Ошибка создания sitemap",
      indexNowDone: "URL отправлены на индексацию",
      indexAllDone: "URL отправлены во все поисковики",
      submitErr: "Ошибка отправки",
      enterJson: "Вставьте JSON-ключ",
      credsSaved: "Credentials Google сохранены",
      instrErr: "Ошибка загрузки инструкций",
      copied: "Скопировано",
      copyErr: "Ошибка копирования",
    },
  },
  reports: {
    title: "Отчёты",
    subtitle: "SEO отчёты и аналитика",
    generate: "Создать отчёт",
    download: "Скачать",
    noReports: "Нет отчётов",
    noReportsDesc: "Создайте первый SEO отчёт",
    site: "Сайт",
    date: "Дата",
    type: "Тип",
    reportLabel: "Отчёт",
    reportFor: "Отчёт:",
    seoScore: "SEO балл",
    audits: "Аудитов",
    keywordsLabel: "Ключевых слов",
    reportDate: "Дата отчёта",
    mainIssues: "Основные проблемы",
    recommendations: "Рекомендации",
    occurrences: (n) => `${n} раз`,
    scoreHistory: "История баллов",
    pointsTitle: (n) => `${n} баллов`,
  },
  common: {
    bulkSelectAll: "Выбрать все",
    bulkClear: "Снять выбор",
    bulkDeleteSelected: "Удалить выбранные",
    bulkDeleteAll: "Удалить все",
    bulkConfirmSelected: (n) => `Удалить выбранные (${n})? Действие необратимо.`,
    bulkConfirmAll: (n) => `Удалить ВСЕ (${n})? Действие необратимо.`,
    bulkDeleted: (n) => `Удалено: ${n}`,
    loading: "Загрузка...",
    save: "Сохранить",
    cancel: "Отмена",
    delete: "Удалить",
    edit: "Изменить",
    add: "Добавить",
    search: "Поиск",
    filter: "Фильтр",
    all: "Все",
    yes: "Да",
    no: "Нет",
    error: "Ошибка",
    success: "Успешно",
    noData: "Нет данных",
    refresh: "Обновить",
    close: "Закрыть",
    select: "Выбрать",
    language: "Язык",
    selectSite: "Выберите сайт",
    fillFields: "Заполните все поля",
    tryAgain: "Попробуйте позже",
    loadError: "Ошибка загрузки",
    copied: "Скопировано",
    copyError: "Ошибка копирования",
    copy: "Копия",
    done: "Готово",
  },

  admin: {
    title: "Админ-панель",
    tabUsers: "Пользователи",
    tabSettings: "Настройки",
    usersHeader: "Пользователи",
    addUser: "Добавить",
    createUser: "Создать пользователя",
    editUser: "Редактировать",
    resetPassword: "Сбросить пароль",
    impersonate: "Войти как",
    email: "Email",
    password: "Пароль",
    newPassword: "Новый пароль",
    passwordAutogen: "Пусто — сгенерируем автоматически",
    passwordHint: "Минимум 8 символов. Покажем один раз.",
    role: "Роль",
    status: "Статус",
    created: "Создан",
    lastLogin: "Последний вход",
    actions: "Действия",
    you: "вы",
    inviteSent: "приглашение активно",
    sendInvite: "Отправить ссылку-приглашение",
    sendInviteDesc: "Пользователь сам задаст пароль по одноразовой ссылке.",
    inviteLink: "Ссылка-приглашение",
    create: "Создать",
    reset: "Сбросить",
    forceChange: "Требовать смену при входе",
    savedOnce: "Скопируйте эти данные сейчас — снова они не появятся.",
    copied: "Скопировано в буфер",
    copyFailed: "Не удалось скопировать",
    userCreated: "Пользователь создан",
    userUpdated: "Пользователь обновлён",
    userDeleted: "Пользователь удалён",
    passwordReset: "Пароль сброшен",
    settingsSaved: "Настройки сохранены",
    impersonateSuccess: (email) => `Вы вошли как ${email}`,
    confirmDelete: (email) => `Удалить пользователя ${email}?`,
    confirmDeleteDesc: "Аккаунт будет удалён немедленно.",
    cascadeTitle: "Удалить все данные пользователя?",
    cascadeDesc: "Удалить все сайты, ключевые слова, историю позиций и статьи этого пользователя. Отменить нельзя.",
    cascadeYes: "Да, вычистить всё",
    cascadeNo: "Нет, оставить данные",
    confirmImpersonate: (email) => `Войти как ${email}?`,
    confirmImpersonateDesc: "Вы выйдете из админ-сессии и войдёте как этот пользователь.",
    resetPasswordFor: (email) => `Сброс пароля для ${email}`,
    searchPlaceholder: "Поиск по email...",
    allRoles: "Все роли",
    allStatuses: "Все статусы",
    empty: "Пользователи отсутствуют",
    emptyDesc: "Измените фильтры или создайте пользователя.",
    notAllowed: "Только для админов",
    notAllowedDesc: "У вас нет прав на эту страницу.",
    selfEmailLocked: "Нельзя менять собственный email.",
    selfRoleLocked: "Нельзя понизить свою роль.",
    selfStatusLocked: "Нельзя выключить себя.",
    roles: { admin: "Админ", user: "Пользователь" },
    statuses: { active: "Активен", disabled: "Отключён" },
    settingsTitle: "Настройки платформы",
    openRegistration: "Открытая регистрация",
    openRegistrationDesc: "Любой, кто знает ссылку, сможет создать аккаунт.",
    defaultRole: "Роль по умолчанию",
    defaultRoleDesc: "Роль новых саморегистраций.",
    minPasswordLen: "Минимум символов в пароле",
    minPasswordLenDesc: "Применяется при создании и сбросе паролей.",
    errors: {
      emailRequired: "Email обязателен",
      loadFailed: "Не удалось загрузить пользователей",
      createFailed: "Не удалось создать пользователя",
      updateFailed: "Не удалось обновить",
      deleteFailed: "Не удалось удалить",
      resetFailed: "Не удалось сбросить пароль",
      impersonateFailed: "Не удалось войти как пользователь",
      saveFailed: "Не удалось сохранить",
    },
    impersonateBanner: (email) =>
      `Вы вошли как ${email} (impersonation). Вернуться в админ-аккаунт.`,
    impersonateBannerReturn: "Вернуться в админ",
    impersonateReturned: "Вы вернулись в админ-аккаунт",
    impersonateReturnFailed: "Не удалось вернуться в админ",
  },

  acceptInvite: {
    title: "Задайте пароль",
    sub: "Выберите пароль, чтобы активировать аккаунт.",
    emailLabel: "Аккаунт",
    passwordLabel: "Пароль",
    passwordHolder: "••••••••",
    confirmLabel: "Повторите пароль",
    minHint: (n) => `минимум ${n} символов`,
    mismatch: "Пароли не совпадают",
    submit: "Активировать аккаунт",
    submitting: "Активируем…",
    success: "Аккаунт активирован",
    loading: "Загружаем приглашение…",
    invalid: "Эта ссылка-приглашение недействительна или истекла.",
    invalidGoLogin: "Перейти к входу",
    backToLogin: "Назад ко входу",
    expiresAt: (when) => `Истекает ${when}`,
  },

  forceChangePassword: {
    title: "Смена пароля",
    sub: "Администратор сбросил ваш пароль — задайте новый, чтобы продолжить.",
    current: "Временный пароль",
    currentHolder: "Вставьте временный пароль",
    nextLabel: "Новый пароль",
    confirmLabel: "Повторите новый пароль",
    minHint: (n) => `минимум ${n} символов`,
    mismatch: "Пароли не совпадают",
    submit: "Сменить пароль",
    submitting: "Меняем…",
    success: "Пароль обновлён",
    signOut: "Выйти",
    error: "Не удалось сменить пароль",
  },

  // NotFound
  notFound: {
    title: "404",
    text: "Страница не найдена",
    cta: "На главную",
  },

  // Score ring buckets
  score: {
    excellent: "Отлично",
    good: "Хорошо",
    average: "Средне",
    poor: "Плохо",
  },

  // Onboarding wizard (shown on Dashboard when 0 sites)
  onboarding: {
    kicker: "// НАЧАЛО · 3 ШАГА",
    welcome: "Добро пожаловать в",
    welcomeProduct: "CBN",
    lead: "Позиции, аудит, контент — автоматически.",
    step1Label: "Добавьте сайт",
    step1Desc: "Подключите домен, чтобы запустить отслеживание и аудиты.",
    step2Label: "Запустите аудит",
    step2Desc: "SEO-балл, robots, sitemap и проблемы постранично.",
    step3Label: "Отслеживайте ключи",
    step3Desc: "Позиции через DataForSEO, статьи через DeepSeek.",
    primaryCta: "+ Добавить первый сайт",
    secondaryCta: "Пропустить — посмотреть дашборд",
  },

  // Settings
  settings: {
    title: "API ключи",
    subtitle: "Ключи внешних сервисов",
    save: "Сохранить",
    saving: "Сохранение...",
    saved: "Сохранено",
    addonTitle: "Подключение Addon",
    addonConnected: "Подключён",
    addonDisconnected: "Не подключён",
    addonConnect: "Подключить",
    addonDisconnect: "Отключить",
  },

  // Content
  content: {
    title: "AI Контент",
    subtitle: "Генерация SEO-контента с ИИ",
    generate: "Сгенерировать",
    generating: "Генерация…",
    copy: "Копировать",
    copied: "Скопировано!",
    selectSite: "Выберите сайт",
    topic: "Тема / ключевое слово",
    topicPlaceholder: "Например: купить iPhone 15",
    language: "Язык",
    noSites: "Нет сайтов",
    noSitesDesc: "Сначала добавьте сайт на странице 'Мои сайты'",
    site: "Сайт",
    contentType: "Тип контента",
    generator: "Генератор",
    result: "Результат",
    history: "История",
    aiWorking: "AI генерирует контент…",
    emptyHint: "Введите тему и нажмите «Сгенерировать»",
    suggestions: "Варианты:",
    topicLabel: "Тема:",
    emptyHistory: "История пуста",
    successGen: "Контент сгенерирован",
    errors: {
      loadSites: "Ошибка загрузки",
      emptyForm: "Выберите сайт и введите тему",
      generate: "Ошибка генерации: ",
      copy: "Ошибка копирования",
      retryLater: "попробуйте позже",
    },
    types: {
      meta_title: { label: "Meta Title", description: "SEO-заголовок страницы (50–60 символов)" },
      meta_description: { label: "Meta Description", description: "Описание для поисковиков (120–155 символов)" },
      h1: { label: "Заголовок H1", description: "Главный заголовок страницы" },
      article_outline: { label: "Структура статьи", description: "План SEO-статьи с заголовками" },
      keywords: { label: "Ключевые слова", description: "Релевантные поисковые запросы" },
    },
  },

  // GoogleSetup
  googleSetup: {
    title: "Настройка Google Indexing",
    subtitle: "Подключение Google Indexing API пошагово",
    back: "К продвижению",
    stepN: "Шаг",
    next: "Далее",
    prev: "Назад",
    done: "Готово — перейти к индексации",
    copied: "Скопировано",
    copyError: "Ошибка копирования",
    warningLabel: "Важно:",
    warningBody:
      "Google Indexing API официально работает для страниц с разметкой JobPosting или BroadcastEvent. Однако многие сайты успешно используют его для обычных страниц.",
    step5ExampleLabel: "Пример email Service Account:",
    quickLinks: "Полезные ссылки",
    links: {
      cloudConsole: "Google Cloud Console",
      searchConsole: "Google Search Console",
      docs: "Документация Google",
    },
    steps: [
      {
        title: "Создайте проект в Google Cloud Console",
        description: "Перейдите на console.cloud.google.com, войдите в Google аккаунт.",
        details: [
          "Нажмите на выпадающий список проектов вверху.",
          "Выберите 'New Project'.",
          "Введите название, например 'SEO Indexing'.",
          "Нажмите 'Create'.",
        ],
        linkText: "Открыть Google Cloud Console",
      },
      {
        title: "Включите Indexing API",
        description: "Активируйте API для индексации.",
        details: [
          "В меню слева выберите 'APIs & Services' → 'Library'.",
          "В поиске введите 'Web Search Indexing API'.",
          "Нажмите на результат.",
          "Нажмите кнопку 'Enable'.",
        ],
        linkText: "Открыть Indexing API",
      },
      {
        title: "Создайте Service Account",
        description: "Создайте сервисный аккаунт для API.",
        details: [
          "Перейдите в 'APIs & Services' → 'Credentials'.",
          "Нажмите 'Create Credentials' → 'Service Account'.",
          "Введите имя, например 'seo-indexer'.",
          "Нажмите 'Create and Continue'.",
          "Роль можно пропустить → 'Continue' → 'Done'.",
        ],
        linkText: "Создать Service Account",
      },
      {
        title: "Скачайте JSON ключ",
        description: "Получите файл с credentials.",
        details: [
          "На странице Credentials нажмите на созданный Service Account.",
          "Перейдите во вкладку 'Keys'.",
          "Нажмите 'Add Key' → 'Create new key'.",
          "Выберите 'JSON' → 'Create'.",
          "Файл скачается автоматически — сохраните его!",
        ],
      },
      {
        title: "Добавьте в Google Search Console",
        description: "Дайте Service Account доступ к вашему сайту.",
        details: [
          "Откройте скачанный JSON и скопируйте 'client_email'.",
          "Перейдите в Google Search Console.",
          "Выберите ваш сайт → Settings → Users and permissions.",
          "Нажмите 'Add user'.",
          "Вставьте email Service Account.",
          "Выберите роль 'Owner'.",
          "Нажмите 'Add'.",
        ],
        linkText: "Открыть Search Console",
      },
      {
        title: "Загрузите JSON в xpnsr SEO",
        description: "Финальный шаг — добавьте ключ в систему.",
        details: [
          "Откройте скачанный JSON файл в текстовом редакторе.",
          "Скопируйте всё содержимое.",
          "В xpnsr SEO: Продвижение → Индексация.",
          "Вставьте JSON в поле 'Google Indexing API'.",
          "Нажмите 'Сохранить Google credentials'.",
        ],
      },
    ],
  },
};
